import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout.vue'

import GradesPage from '@/pages/Grades/grades.vue'
import {RouteConfig} from 'vue-router'

// @ts-ignore
import messages from '@/lang/index'

const grades: RouteConfig = {
  path: '/grades',
  name: 'grades',
  meta: {
    pageName: messages.common.grades_pagename
  },
  component: DashboardLayout,
  redirect: '/grades/list',
  children: [
    {
      path: 'list',
      name: 'gradesPage',
      meta: {
        pageName: messages.common.grades_list_pagename
      },
      component: GradesPage
    }
  ]
}

export default grades